import React, { Component } from 'react';
import PortalCheckBox from '../controls/checkbox';
import WindowedList from '../../portal/windowedList';

export default class CheckboxList extends Component {

    visibleItems = [];
    
    createCheckBox = (item, displayLable) => {
        
        return (
            <PortalCheckBox
                dataKey={ item.itemData.id }
                checked={ item.selected }
                onCheck={this.props.toggleSelection}
                label={ displayLable ? item.itemData.name : '' }
                disabled={item.disabled}
                dataCy={`role-${item.itemData.id}-checkbox-${this.props.edit}`}
            />
        );
    }

    createItemRow = (item, style) => {

        let row = null;
        const selectedClass = item.selected ? ' selected' : '';
        const disabledClass = item.disabled ? ' disabled' : '';
        const rowClassName = `item-container list-content${selectedClass}`;
        const mainRow = (this.props.formatMainRow != undefined) ? this.props.formatMainRow(item.itemData) : item.itemData.name;

        if (this.props.formatAdditionalData != undefined) {
            
            var additionalData = this.props.formatAdditionalData(item.itemData);
            row = <div className={rowClassName} key={item.itemData.id} style={style}>
                    <div></div>
                    <div>
                        {this.createCheckBox(item)}
                    </div>
                    <div className='checkbox-item'>
                        <div className={`item-name ${disabledClass}`} title={mainRow}>
                            {mainRow}
                        </div>
                        <div className={`item-additional-data ${disabledClass}`} title={additionalData}>
                            {additionalData}
                        </div>
                    </div>
                </div>
        }
        else {
            row = <div className='item-row' key={item.itemData.id} style={style}>
                        {this.createCheckBox(item, true)}
                  </div>;
        }

        return row;
    }

    rowRenderer = ({key, index, isScrolling, isVisible, style}) => {
        
        var item = this.visibleItems[index];
        return this.createItemRow(item, style);
    }

    render() { 

        this.visibleItems = this.props.selectableList.filter((item) => item.visible);
        
        return(
            <div className='checkbox-list'>
                <WindowedList
                    height={this.props.height}
                    rowCount={this.visibleItems.length}
                    rowHeight={this.props.rowHeight}
                    rowRenderer={this.rowRenderer}
                    scrollbarOverlay={true}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/controls/checkboxList.jsx